<template>
    <div
        class="uk-height-1-1 uk-width-1-1 uk-background-primary uk-border-rounded uk-box-shadow-bottom uk-box-shadow-small uk-padding-small uk-flex uk-flex-middle graph-container"
    >
        <div class="graph-buttons uk-width-1-1">
            <graph-help :graph-id="id" />
        </div>
        <graph-submenu :position="graphPosition" />
        <div class="uk-position-medium uk-position-top-left">
            <span class="uk-text-large uk-text-lead uk-text-bolder">{{ total }}</span>
            <span
                class="uk-text-small"
                :class="{ 'uk-text-danger': difference < 0, 'uk-text-success': difference > 0 }"
            >
                {{ difference }}%</span
            ><br />
            <span class="uk-text-meta">{{ title }}</span
            ><br />
        </div>
        <div class="uk-flex uk-flex-column custom-box uk-position-bottom-center uk-margin-medium-bottom">
            <div class="uk-grid">
                <div class="uk-width-1-3@s">
                    <span class="uk-text-large uk-text-lead uk-text-bolder">{{ chartDataIn[0].data[0] }}</span>
                    <span class="uk-text-meta">IN</span>
                </div>
                <apexcharts
                    ref="chartIn"
                    class="uk-width-2-3@s"
                    :width="getChartWidth"
                    :height="getChartHeight"
                    type="bar"
                    :options="getChartOptions"
                    :series="chartDataIn"
                />
            </div>
            <div class="uk-grid">
                <div class="uk-width-1-3@s">
                    <span class="uk-text-large uk-text-lead uk-text-bolder">{{ chartDataOut[0].data[0] }}</span>
                    <span class="uk-text-meta">OUT</span>
                </div>
                <apexcharts
                    ref="chartOut"
                    class="uk-width-2-3@s"
                    :width="getChartWidth"
                    :height="getChartHeight"
                    type="bar"
                    :options="defaultChartOptions"
                    :series="chartDataOut"
                />
            </div>
            <div class="uk-grid">
                <div class="uk-width-1-3@s">
                    <span class="uk-text-large uk-text-lead uk-text-bolder">{{ chartDataTotal[0].data[0] }}</span>
                    <span class="uk-text-meta">TOTAL</span>
                </div>
                <apexcharts
                    ref="chartTotal"
                    class="uk-width-2-3@s"
                    :width="getChartWidth"
                    :height="getChartHeight"
                    type="bar"
                    :options="getChartOptionsTotal"
                    :series="chartDataTotal"
                />
            </div>
        </div>

        <slot />

        <graph-modal :graph-id="id" :title="title" :description="description" />
    </div>
</template>

<script lang="js">
import GraphSubmenu from "./graphParts/GraphSubmenu.vue";
import GraphHelp from "./graphParts/GraphHelp.vue";
import GraphModal from "./graphParts/GraphModal.vue";

export default {
    name: "AppsConversationGraph",
    components: { GraphSubmenu, GraphHelp, GraphModal },
    props: {
        chartDataIn: {
            type: Array,
            required: true,
        },
        chartDataOut: {
            type: Array,
            required: true,
        },
        chartDataTotal: {
            type: Array,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        dataPath: {
            type: String,
            required: false,
        },
        graphPosition: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            activeSubmenu: false,
            total: 0,
            defaultChartOptions: {
                chart: {
                    toolbar: {
                        show: false,
                    },
                    sparkline: {
                        enabled: true,
                    },
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        endingShape: "rounded",
                        startingShape: "rounded",
                        distributed: true,
                        barHeight: "22%",
                        colors: {
                            backgroundBarColors: ["#FF006C1A"],
                            backgroundBarRadius: "5",
                        },
                    },
                },
                colors: ["#ff006c"],
                dataLabels: {
                    enabled: false,
                    color: "#B0B0B0",
                },
                grid: {
                    borderColor: "#F3F6F8",
                },
                xaxis: {
                    axisTicks: {
                        color: "#F3F6F8",
                    },
                    axisBorder: {
                        color: "#F3F6F8",
                    },
                    categories: ["M"],
                },
                yaxis: {
                    max: 0,
                },
                legend: {
                    show: false,
                },
            },
        };
    },
    computed: {
        getChartOptions() {
            this.defaultChartOptions.yaxis.max = this.total;
            return this.defaultChartOptions;
        },
        getChartOptionsTotal() {
            this.defaultChartOptions.plotOptions.bar = {
                horizontal: true,
                endingShape: "rounded",
                startingShape: "rounded",
                distributed: true,
                barHeight: "22%",
                colors: {
                    backgroundBarColors: ["#F1E5FF"],
                    backgroundBarRadius: "5",
                },
            };
            this.defaultChartOptions.colors = ["#8720E0"];
            this.defaultChartOptions.yaxis.max = this.total;
            return this.defaultChartOptions;
        },
        getChartWidth() {
            return this.$store.state.graphs.defaultAppsConvGraphWidth;
        },
        getChartHeight() {
            return this.$store.state.graphs.defaultAppsConvGraphHeight;
        },
    },
};
</script>
